import { IonPage } from '@ionic/react';

import { ChangeEvent } from 'react';
import { Checkbox } from '../components/Forms/Checkbox';
import { Header } from '../components/Header';
import { IconButton } from '../components/IconButton';
import { IconArrowBack, IconCheck } from '../components/QuirkIcons';
import { QuirkIonContent } from '../components/QuirkIonContent';
// eslint-disable-next-line css-modules/no-unused-class
import sharedStyles from '../styles/Shared.module.css';

export const EventFilters: React.FC<{
	userFilter: boolean;
	myInterestedEventsFilter: boolean;
	handleCheckboxChange: () => void;
	onDismiss: (e: ChangeEvent<HTMLInputElement>) => {};
}> = ({ onDismiss, userFilter, myInterestedEventsFilter, handleCheckboxChange }) => {
	return (
		<IonPage>
			<Header
				title="Filter Events"
				left={<IconButton icon={<IconArrowBack />} onClick={onDismiss} />}
				right={<IconButton label="Apply" icon={<IconCheck />} onClick={onDismiss} />}
			/>
			<QuirkIonContent>
				<div>
					<div className={sharedStyles.contentWrapper}>
						<Checkbox
							value={userFilter}
							name="myEvents"
							label="Events I created"
							onClick={handleCheckboxChange}
						/>
						<div className="space20" />
						<Checkbox
							value={myInterestedEventsFilter}
							name="interestedEvents"
							label="Events I'm interested in"
							onClick={handleCheckboxChange}
						/>
					</div>
				</div>
			</QuirkIonContent>
		</IonPage>
	);
};
